export function rows(description, limit) {
  let count = description.split('\n').length + 1;
  if (count > limit) {
    count = limit;
  }
  return count;
}
